/*
 * @Description:
 * @Author: luokang
 * @Date: 2023-02-22 10:59:56
 */
import { AppKey } from '../utils/const'
export default {
  data() {
    return {
      captcha: ''// 滑块验证码实例
    }
  },
  computed: {
    // 国际化语言
    lang() {
      return this.$store.state.base.lang
    }
  },
  mounted() {
    this.initTencentCaptcha()
  },
  methods: {
    // 初始化tx验证码
    initTencentCaptcha() {
      // 生成实例对象
      this.captcha = window.CaptchaSDK && window.CaptchaSDK.init(this.tencentCaptchaCallback, {
        forceLang: this.lang === 'CN' ? 'zh-cn' : 'en'
      })
    },
    // 验证码回调
    async tencentCaptchaCallback(res) {
      console.log('腾讯验证码回调：callback', res)
      // 验证成功，返回对象
      if (res.ret === 0) {
        // 定义参数：票据 随机字符串
        const customParams = {
          ticket: res.ticket,
          randstr: res.randstr
        }
        // console.log('customParams==', customParams)
        this.submitForm(customParams)
      }
      // 验证不成功
      return null
    }
  }
}
